<mat-card
  class="profile-menu-btn"
  [class.profile-menu-btn--loading]="!displayNameReady"
  #menuTrigger="matMenuTrigger"
  (click)="displayNameReady && menuTrigger.openMenu()"
  [mat-menu-trigger-for]="menu"
>
  <mat-card-header class="profile-header">
    <img
      *ngIf="picLoaded"
      [src]="playerSrc"
      mat-list-avatar
      class="profileImage profile-avatar-circle"
      alt=""
      (error)="onProfileImageError()"
    />
    <i *ngIf="!picLoaded" class="fas fa-user-circle avatarImg profile-avatar-circle"></i>
    <mat-spinner *ngIf="!displayNameReady" class="profile-name-spinner" diameter="20"></mat-spinner>
    <span *ngIf="displayNameReady" class="profile-fullname" [title]="fullName || userName">{{
      fullName || userName
    }}</span>
  </mat-card-header>

  <mat-menu id="userMenu" #menu="matMenu" class="profileMenu user-menu-panel" yPosition="above" xPosition="after">
    <mat-list>
      <mat-list-item class="profile-item" disableRipple>
        <img
          *ngIf="picLoaded"
          matListItemAvatar
          [src]="playerSrc"
          class="profileImage"
          alt=""
          (error)="onProfileImageError()"
        />
        <i *ngIf="!picLoaded" matListItemAvatar class="fas fa-user-circle avatarImg"></i>
        <div class="profile-user-meta">
          <div class="user-name-text" [title]="userName">{{ userName }}</div>
          <div class="access-level-text" [title]="currentAccess">{{ currentAccess }}</div>
        </div>
        <span id="divSwitchButton" class="switch-g-btn" title="Switch user"></span>
      </mat-list-item>
      <div *ngIf="showTenants" class="tenant-spacer"></div>
      <mat-divider></mat-divider>
      <mat-list-item class="version-item" disableRipple>
        <span mat-line>Version {{ appVersion }}</span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item class="menu-link" (click)="openHelp()">
        <span mat-line>Help</span>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item id="logout" class="menu-link emph-link logout-item" (click)="logout()" style="font-weight:600">
        <span mat-line><i class="far fa-sign-out-alt"></i> Sign out</span>
      </mat-list-item>
    </mat-list>
  </mat-menu>
</mat-card>
